"use client";
import React, { useEffect, useRef } from "react";

const ReadingProgressBar = () => {
  const barRef = useRef(null);

  useEffect(() => {
    let ticking = false;
    let maxScroll = 0;

    const updateMaxScroll = () => {
      if (typeof window === "undefined") return;
      const el = document.documentElement;
      const scrollHeight = el.scrollHeight || document.body.scrollHeight || 0;
      const windowHeight = window.innerHeight || el.clientHeight || 1;
      maxScroll = Math.max(0, scrollHeight - windowHeight);
    };

    const updateProgress = () => {
      const scrollTop = window.scrollY || 0;
      const progress = maxScroll > 0 ? Math.min(1, Math.max(0, scrollTop / maxScroll)) : 0;

      if (barRef.current) {
        barRef.current.style.transform = `scaleX(${progress})`;
      }
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateProgress);
        ticking = true;
      }
    };

    updateMaxScroll();
    window.addEventListener("resize", updateMaxScroll, { passive: true });
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener("resize", updateMaxScroll);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      ref={barRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "4px",
        background: "linear-gradient(to right, #F48428, #ff9d4d)",
        zIndex: 9999,
        transformOrigin: "left center",
        transform: "scaleX(0)",
        willChange: "transform",
        boxShadow: "0 0 10px rgba(245, 131, 39, 0.5)",
        pointerEvents: "none",
      }}
    />
  );
};

export default ReadingProgressBar;
